class UserFieldValidator
{

  constructor() {
    const now = new Date();

    this.validationMap = {
      'firstName': [
        {
          'rule': 'regex',
          'statement': '^[^\\^\\!\\#\\$\\%\\@\\*\\=\\<\\>\\;\\{\\}\\"]{1,255}$',
          'message': 'First Name shouldn`t contain special characters.'
        }
      ],
      'middleName': [
        {
          'rule': 'regex',
          'statement': '^[^\\^\\!\\#\\$\\%\\@\\*\\=\\<\\>\\;\\{\\}\\"]{1,255}$',
          'message': 'Middle Name shouldn`t contain special characters.'
        }
      ],
      'lastName': [
        {
          'rule': 'regex',
          'statement': '^[^\\^\\!\\#\\$\\%\\@\\*\\=\\<\\>\\;\\{\\}\\"]{1,255}$',
          'message': 'Last Name shouldn`t contain special characters.'
        }
      ],
      'fullName': [
        {
          'rule': 'regex',
          'statement': '^[^\\^\\!\\#\\$\\%\\@\\*\\=\\<\\>\\;\\{\\}\\"]{1,255}$',
          'message': 'Full Name shouldn`t contain special characters.'
        }
      ],
      'givenName': [
        {
          'rule': 'regex',
          'statement': '^[^\\^\\!\\#\\$\\%\\@\\*\\=\\<\\>\\;\\{\\}\\"]{1,255}$',
          'message': 'Given Name shouldn`t contain special characters.'
        }
      ],
      'dobYear': [
        {
          'rule': 'range',
          'statement': [1900, now.getFullYear()],
          'message': 'Dob Year should be between 1900 and current year.'
        }
      ],
      'suffix': [
        {
          'rule': 'length',
          'statement': [1, 128],
          'message': 'Suffix should contain from 1 up to 128 characters.'
        }
      ],
      'gender': [
        {
          'rule': 'regex',
          'statement': '^[M|F]$',
          'message': 'Gender should be M or F.'
        }
      ],
      'dobMonth': [
        {
          'rule': 'range',
          'statement': [1, 12],
          'message': 'Dob Month should be between 1 and 12.'
        }
      ],
      'dobDay': [
        {
          'rule': 'range',
          'statement': [1, 31],
          'message': 'Dob Day should be between 1 and 31.'
        }
      ],
      'expirationYear': [
        {
          'rule': 'range',
          'statement': [now.getFullYear() - 100, now.getFullYear() + 100],
          'message': 'ID Expiration Year should be between ' + (now.getFullYear() - 100) + ' and ' + (now.getFullYear() + 100) + '.'
        }
      ],
      'expirationMonth': [
        {
          'rule': 'range',
          'statement': [1, 12],
          'message': 'ID Expiration Month should be between 1 and 12.'
        }
      ],
      'expirationDay': [
        {
          'rule': 'range',
          'statement': [1, 31],
          'message': 'ID Expiration Day should be between 1 and 31.'
        }
      ],
      'issueYear': [
        {
          'rule': 'range',
          'statement': [1900, now.getFullYear()],
          'message': 'ID Issue Year should be between 1900 and current year.'
        }
      ],
      'issueMonth': [
        {
          'rule': 'range',
          'statement': [1, 12],
          'message': 'ID Issue Month should be between 1 and 12.'
        }
      ],
      'issueDay': [
        {
          'rule': 'range',
          'statement': [1, 31],
          'message': 'ID Issue Day should be between 1 and 31.'
        }
      ],
      'street': [
        {
          'rule': 'regex',
          'statement': '^[^\\!\\$\\%\\@\\^\\*\\=\\<\\>]{1,255}$',
          'message': 'Street shouldn`t contain special characters.'
        }
      ],
      'subStreet': [
        {
          'rule': 'regex',
          'statement': '^[^\\!\\$\\%\\@\\^\\*\\=\\<\\>]{1,255}$',
          'message': 'Sub Street shouldn`t contain special characters.'
        }
      ],
      'building': [
        {
          'rule': 'length',
          'statement': [1, 32],
          'message': 'Building should contain from 1 up to 32 characters.'
        }
      ],
      'buildingName': [
        {
          'rule': 'regex',
          'statement': '^[^\\!\\$\\%\\@\\^\\*\\=\\<\\>]{1,255}$',
          'message': 'Building Name shouldn`t contain special characters.'
        }
      ],
      'address': [
        {
          'rule': 'regex',
          'statement': '^[^\\!\\$\\%\\@\\^\\*\\=\\<\\>]{1,255}$',
          'message': 'Address shouldn`t contain special characters.'
        }
      ],
      'flatNumber': [
        {
          'rule': 'length',
          'statement': [1, 128],
          'message': 'Flat Number should contain from 1 up to 128 characters.'
        }
      ],
      'city': [
        {
          'rule': 'regex',
          'statement': '^[^\\!\\$\\%\\@\\^\\*\\=\\<\\>]{1,255}$',
          'message': 'City shouldn`t contain special characters.'
        }
      ],
      'country': [
        {
          'rule': 'regex',
          'statement': '^[A-Z]{2}$',
          'message': 'Country should contain a valid ISO 3166-1 Alpha-2 country code.'
        }
      ],
      'county': [
        {
          'rule': 'length',
          'statement': [1, 255],
          'message': 'County should contain from 1 up to 255 characters.'
        }
      ],
      'state': [
        {
          'rule': 'regex',
          'statement': '^[A-Z]{2}$',
          'message': 'State should contain a valid ISO 3166-2:US 2 characters state code.'
        }
      ],
      'zip': [
        {
          'rule': 'length',
          'statement': [1, 255],
          'message': 'Zip should contain from 1 up to 255 characters.'
        }
      ],
      'phone': [
        {
          'rule': 'regex',
          'statement': '^\\d{7}(\\d{3})+$',
          'message': 'Phone should contain 10 digits.'
        }
      ],
      'email': [
        {
          'rule': 'regex',
          'statement': '^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$',
          'message': 'Email should contain a valid email address.'
        }
      ],
      'ssn': [
        {
          'rule': 'regex',
          'statement': '^\\d{4}(\\d{5})+$',
          'message': 'SSN should contain a valid SSN.'
        }
      ],
      'idNumber': [
        {
          'rule': 'length',
          'statement': [1, 255],
          'message': 'ID Number should contain from 1 up to 255 characters.'
        }
      ],
      'idType': [
        {
          'rule': 'regex',
          'statement': '^[Driving License|Residence Permit|Passport|ID Card|drivingLicense|residencePermit|idCard]+$',
          'message': 'ID Type is not supported.'
        }
      ],
      'gupiId': [
        {
          'rule': 'length',
          'statement': [64, 64],
          'message': 'GUPI should strictly contain 64 characters.'
        },
        {
          'rule': 'regex',
          'statement': '^[0-9,a-z]$',
          'message': 'GUPI shouldn`t contain spaces and special characters.'
        }
      ],
      'ipAddress': [
        {
          'rule': 'regex',
          'statement':
            '^\\d{1,3}\\.\\d{1,3}.\\d{1,3}.\\d{1,3}$|' +
            '^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|' +
            '([0-9a-fA-F]{1,4}:){1,7}:|' +
            '([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|' +
            '([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|' +
            '([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|' +
            '([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|' +
            '([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|' +
            ':((:[0-9a-fA-F]{1,4}){1,7}|:)|' +
            'fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|' +
            '::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|' +
            '(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|' +
            '(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|' +
            '([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|' +
            '(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|' +
            '(2[0-4]|1{0,1}[0-9]){0,1}[0-9])$)',
          'message': 'IP Address should contain a valid IPv4 or IPv6 address.'
        }
      ],
    }
  }

  validate(fieldName, value) {
    if (value) {
      let validationRules = this.validationMap[fieldName];
      let validationResult = {
        'fieldName': fieldName,
        'result': true,
      };

      if (validationRules) {
        validationRules.every((validationRule) => {
          switch(validationRule.rule) {
            case 'regex':
              if (!this.regex(validationRule.statement, value)) {
                validationResult.result = false;
                validationResult.message = validationRule.message;

                return false;
              }
              break;
            case 'range': {
              if (!this.range(validationRule.statement, value)) {
                validationResult.result = false;
                validationResult.message = validationRule.message;

                return false;
              }
              break;
            }
            case 'length': {
              if (!this.length(validationRule.statement, value)) {
                validationResult.result = false;
                validationResult.message = validationRule.message;

                return false;
              }
              break;
            }
          }
        });
      }

      return validationResult;
    }
  }

  regex(regex, value) {
    let regexp = new RegExp(regex);

    return regexp.test(value);
  }

  length(statement, value) {
    let min = statement[0];
    let max = statement[1];

    return !(value.length < min || value.length > max);
  }

  range(statement, value) {
    let min = statement[0];
    let max = statement[1];

    return !(value < min || value > max);
  }
}

export { UserFieldValidator }